import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  constructor(
    private api : ApiService,
  ) { }
      
  async getRoute(req?:any){
    return new Promise((reslove,reject)=>{
      this.api.getRoute().subscribe((res:any)=>{
        if(res && res.code == 1){
          return reslove(res.data);
        }else{
          return reslove(false);
        }
      })
    })
  }
  async getDevicePermission(req?:any){
    return new Promise((reslove,reject)=>{
      this.api.getDevicePermission(req).subscribe((res:any)=>{
        if(res && res.code == 1){
          return reslove(res.data);
        }else{
          return reslove(false);
        }
      })
    })
  }
  async getDeviceSmc(req?:any){
    return new Promise((reslove,reject)=>{
      this.api.getDeviceSmc(req).subscribe((res:any)=>{
        if(res && res.code == 1){
          return reslove(res.data.data);
        }else{
          return reslove(false);
        }
      })
    })
  }
}